import React from 'react';
import { Button, IconButton, Paper, DialogTitle, DialogContent, DialogActions, TextField, Tooltip, Divider, Checkbox, } from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from "@mui/x-data-grid/locales";
import { D, SearchField, ConfirmDialog, UploadFiles } from '../include';
import _ from 'underscore';

class EditCompany extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      name: this.props.row ? this.props.row.name : '',
      previous_logo_file_id: this.props.row ? this.props.row.logo_file_id : -1,
      logo_file_id: this.props.row ? this.props.row.logo_file_id : -1, 
      file_thumb: null,
    };
  }
  
  componentDidMount() {
    if(this.state.logo_file_id > 0)
      this.getFileFromFileServer(this.state.logo_file_id);
  }
  

  handleSubmit = () => {
    if (!this.props.edit) {
      this.props.api
        .post('/Companies/', { name: this.state.name, logo_file_id: this.state.logo_file_id })
        .then((r) => {
          this.props.dialogClose();
          this.props.alert('Registro criado com sucesso');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao criar o registro'));
    } else {
      this.props.api
        .put('/Company/' + this.props.row.id, { id: this.props.row.id, name: this.state.name, logo_file_id: this.state.logo_file_id, previous_logo_file_id: this.state.previous_logo_file_id })
        .then(() => {
          this.props.dialogClose();
          this.props.alert('Alterações salvas com sucesso');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao salvar alterações'));
    }
  };
  
  
  handleDBRecord = (record, error) => {
    if(!error){
      this.setState({logo_file_id: record.id });
      this.getFileFromFileServer(this.state.logo_file_id);
    }
  }
  
  
  getFileFromFileServer = (id) => {
    this.props.api
      .get('/FileServer/file/' + id, {responseType: 'blob'})
      .then((r) => {
        if( r.type !== "application/json" ){  
          const url = URL.createObjectURL(r);
        
          // in case you don't need the blob anymore, blob can be garbage collected
          //img.onload = e => URL.revokeObjectURL(url);
        
          this.setState({file_thumb: url});
        }
        else{
          try{  
          const outurl = URL.createObjectURL(r);
          fetch(outurl).then(res => {
            res.text().then(txt => {
              var dic = JSON.parse(txt);
              var msg = dic.error
              if(dic.coldstorage)
                msg = msg + ". Arquivo dispónível somente no coldstorage."
              this.props.alert(msg);
            });  
          });
          }catch(err){
            console.log(err);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });       
  }
    

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <DialogTitle style={{ minWidth: '400px' }}>
          {this.props.edit ? 'Editar Empresa' : 'Adicionar Empresa'}
        </DialogTitle>
        <DialogContent>
          {this.state.file_thumb && <iframe title="logoFrame" src={this.state.file_thumb} frameBorder="0" scrolling="yes" width='100%' />}
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".jpg, .png, .jpeg"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error) }}
            registerIntoDB={true}
            caption="Recomendado 82-100px (largura-w) x 82px (altura-h), transparente"
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Nome"
            value={this.state.name}
            onChange={(e) => this.setState({ name: e.target.value })}
            required
          />
          <D h="2rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" type="submit">
            Salvar
          </Button>
        </DialogActions>
      </form>
    );
  }
}

export class Company extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchField: '',
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      selectedRows: [],
    };

    this.columns = [
      ...(this.props.permission === 'w'
        ? [
            {
              field: "check",
              headerName: "Seleção",
              width: 100,
              sortable: false,
              renderCell: (params) => (
                <Checkbox checked={this.state.selectedRows.includes(params.row) } onChange={() => this.onRowClick(params.row)} />
              ),
            },
          ]
        : []),
      { field: 'id', headerName: 'ID', width: 70 },
      { field: 'name', headerName: 'Empresa', width: 300 },
      { field: 'logo_file_id', headerName: 'Logo ID', width: 70 },
    ];
  }

  componentDidMount() {
    this.updateData();
  }

  updateData = (page = this.state.page, pageSize = this.state.pageSize, searchField = this.state.searchField) => {
    this.setState({ loading: true });
    this.props.api
      .get('/Companies', { params: { page, pageSize, search: searchField } })
      .then((r) => {
        this.setState({
          dataTable: r.companies || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.updateData(0, this.state.pageSize, this.state.searchField);
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  onRowClick = (i) => {
    this.setState({
      selectedRows: this.state.selectedRows.includes(i) ? _.without(this.state.selectedRows, i) : _.union(this.state.selectedRows, [i])
    });
  };
  
  render() {
    const { searchField, dataTable, loading, page, pageSize, totalRows } = this.state;

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
        />
        <Tooltip title="Pesquisar" arrow>
          <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
              
        {this.props.permission === 'w' && (
          <> 
              <Divider sx={{ paddingRight: '5px' }} orientation="vertical" flexItem />
              <D size="0.5rem" />

              {this.state.selectedRows.length === 1 && (
                <>
                  <Tooltip title="Editar item" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <EditCompany
                            edit
                            row={this.state.selectedRows[0]}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                              this.setState({ selectedRows: [] });
                              this.updateData();
                            }}
                          />
                        )
                      }
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              {this.state.selectedRows.length > 0 && (
                <>
                  <Tooltip title="Excluir selecionados" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <ConfirmDialog
                            title="Excluir Itens"
                            msg="Ao confirmar, os itens serão excluídos e não poderão ser recuperados"
                            reg={
                              this.state.selectedRows.length > 1
                                ? this.state.selectedRows.length + " registros selecionados"
                                : "1 registro selecionado"
                            }
                            onCancel={this.props.dialogClose}
                            onConfirm={() => {
                              for (let row of this.state.selectedRows) {
                                this.props.api
                                  .delete("/Company/" + row.id)
                                  .then((r) => {
                                    this.props.alert(r.message);
                                    this.props.dialogClose();
                                    this.setState({ selectedRows: [] });
                                    this.updateData();
                                  })
                                  .catch(() => this.props.alert("Ocorreu um erro ao excluir o registro"));
                              }
                            }}
                          />
                        )
                      }
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              <D e />
              <Tooltip title="Inserir" arrow>
                <IconButton
                  sx={{ marginLeft: '12px' }}
                  onClick={() =>
                    this.props.dialog(
                      <EditCompany
                        edit={false}
                        row={null}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.setState({ selectedRows: [] });
                          this.updateData();
                        }}
                      />
                    )
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
          </>
        )}
          </D>
        <D h="1rem" />
        
        <Paper sx={{ width: '100%', height: '800px', overflow: 'hidden' }}>
          <DataGrid
            rows={dataTable}
            columns={this.columns}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
        </Paper>
      </D>
    );
  }
}
